import React, { forwardRef } from "react";
import TextField from "@mui/material/TextField";

interface InputProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder: string;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

const CustomInput = forwardRef<HTMLInputElement, InputProps>(
  ({ value, onChange, placeholder,onKeyDown }, ref) => (
    <TextField
      value={value}
      onChange={onChange}
      label={placeholder}
      inputRef={ref}
      variant="outlined"
      onKeyDown={onKeyDown}
      style={{ marginRight: "10px"}}
      fullWidth
    />
  )
);

export default CustomInput;
